(ns frontend.ui.component.lp-portal.report.component.horizontal-table.view
  (:require
   [common.date-formats :as date]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.style :as style]
   [frontend.ui.component.lp-portal.voima-components.card.view :as card]
   [frontend.ui.component.lp-portal.voima-components.text-content.view :as text-content]
   [frontend.ui.page.lp-portal.report.util :as report-utils]
   [frontend.ui.style.theme.core :as theme]
   [frontend.utils :as fu]
   [herb.core :as h]))


(defn heading-row-spanned
  [heading]
  (into [:tr
         {:class (h/<class style/heading-tr)}]
        (->> heading
             :cols
             (keep (fn [{:keys [span label]}]
                     (when-not (zero? span)
                       [:th
                        (merge {:class (h/<class style/th-spanned label)}
                               (when (pos? span)
                                 {:col-span span}))
                        (or label "")]))))))

(defn heading-row-heading
  [heading data-types]
  (into [:tr
         {:class (h/<class style/heading-tr)}]
        (->> heading
             :cols
             (map-indexed (fn [idx lbl]
                            [:th
                             {:class (h/<class style/th-heading lbl idx (nth data-types idx))}
                             (or lbl "")]))
             (vec))))


(defn heading-row-info
  [heading data-types]
  (into [:tr
         {:class (h/<class style/heading-tr)}]
        (->> heading
             :cols
             (map-indexed (fn [idx lbl]
                            [:th
                             {:class (h/<class style/th-info lbl idx (nth data-types idx))}
                             (or lbl "")]))
             (vec))))

(defn format-data
  [col-data-type col-decimals col-multipliers col-date-format col-empty-indicator row-style data]
  (let [col-decimals-set? (not (cu/blank-value? col-decimals))
        data-available? (not (cu/blank-value? data))
        date-format-set? (not (cu/blank-value? col-date-format))
        is-data-row? (or (cu/blank-value? row-style) (= row-style "note"))
        multiplier (if (not (cu/blank-value? col-multipliers))
                     col-multipliers
                     1)
        decimal-amount (if col-decimals-set?
                         col-decimals
                         (case col-data-type
                           :table-data-type/currency 1
                           :table-data-type/number 2
                           :table-data-type/percentage 0
                           :table-data-type/multiple 1
                           nil))]
    (if data-available?
      (case col-data-type
        :table-data-type/date
        (if date-format-set?
          (date/format-millis data col-date-format nil)
          (date/format-millis data "dd.MM.yyyy" nil))

        :table-data-type/currency
        ;;TODO do we want the option to include suffix??
        (fu/number-string->thousand-separators
         (report-utils/->float-x-decimals (/ data multiplier) decimal-amount)
         ","
         ".")
        :table-data-type/multiple
        ;;TODO should we give options for the multiplier symbol?
        (report-utils/->float-x-decimals "x" data decimal-amount)
        :table-data-type/number
        (fu/number-string->thousand-separators
         (report-utils/->float-x-decimals (/ data multiplier) decimal-amount)
         ","
         ".")
        :table-data-type/percentage
        (fu/format-percentage-with-decimals data decimal-amount)
        :table-data-type/text
        (str data))
      (or (and is-data-row? col-empty-indicator) nil))))

(defn data-row
  [{:keys [column-data-types column-decimals column-multipliers alignment-row highlight-row
           empty-indicator-row text-style-row format-row column-style-row _headers
           _heading-count _rows table-style]}
   {:keys [row-data row-highlight row-type row-font-style row-style] :as _row}
   row-idx even-row-background-color odd-row-background-color sub-heading-color
   sub-total-color total-color empty-line-color]
  (into
   ^{:key (gensym "key-")}
   [:tr
    {:class (h/<class (partial style/data-row-horizontal-table
                               row-type
                               row-highlight
                               row-font-style
                               row-style
                               row-idx
                               even-row-background-color
                               odd-row-background-color
                               sub-heading-color
                               sub-total-color
                               total-color
                               empty-line-color
                               table-style))}]
   (->>
    column-data-types
    (map-indexed
     (fn [idx col-data-type]
       (let [column-decimal (nth column-decimals idx nil)
             column-multiplier (nth column-multipliers idx nil)
             column-date-format (nth format-row idx nil)
             column-alignment (nth alignment-row idx nil)
             column-color (nth highlight-row idx nil)
             column-text-style (nth text-style-row idx nil)
             column-empty-indicator (nth empty-indicator-row idx nil)
             column-style (nth column-style-row idx nil)]
         ^{:key (gensym "key-")}
         [:td
          {:class (h/<class (partial style/data-row-td
                                     column-alignment
                                     col-data-type
                                     column-color
                                     column-text-style
                                     column-style
                                     idx))}
          (format-data col-data-type
                       column-decimal
                       column-multiplier
                       column-date-format
                       column-empty-indicator
                       row-type
                       (nth row-data idx nil))]))))))

(defn dynamic-table
  [{:keys [parsed-data even-row-background-color odd-row-background-color sub-heading-color
           sub-total-color total-color empty-line-color]
    :as   props}]
  (let [{:keys [column-data-types _column-decimals _column-multipliers _format-row headers
                heading-count rows _table-style]}
        parsed-data
        last-heading-idx (atom 0)]
    (if-not column-data-types
      [:div (loc/tr :lp-report-template-incorrect-table-data)]
      [:div
       {:class (h/<class style/scroll-container)}
       [:table
        {:class (h/<class style/dynamic-table props)}
        (when (pos? heading-count)
          (into [:thead]
                (->> (range heading-count)
                     (mapv (fn [idx]
                             (let [hr (nth headers idx)]
                               (case (:header-type hr)
                                 :header-type/spanned
                                 (heading-row-spanned hr)
                                 :header-type/info
                                 (heading-row-info hr column-data-types)
                                 :header-type/heading
                                 (heading-row-heading hr column-data-types)
                                 (str "No header type " (:header-type hr))
                                 )))))))
        (when (pos? (count rows))
          (into [:tbody]
                (->> rows
                     (map-indexed (fn [idx row]
                                    (let [row-type (:row-type row)
                                          row-idx (if (some #(= row-type %)
                                                            ["subheading" "subtotal" "empty line" "total"])
                                                    (do (reset! last-heading-idx idx) 0)
                                                    (- idx @last-heading-idx))]
                                      (data-row parsed-data
                                                row
                                                row-idx
                                                even-row-background-color
                                                odd-row-background-color
                                                sub-heading-color
                                                sub-total-color
                                                total-color
                                                empty-line-color)))))))
        ]])))

(defn table
  [name
   {:keys [_rich-content _rich-content-path figures] :as data}
   {:keys [_edit-mode? _save-text] :as props}]
  (let [removed-since-empty? (->> data
                                  :figures
                                  :rows
                                  (filter (fn [{:keys [row-data]}]
                                            (seq (remove nil? row-data))))
                                  (count)
                                  (= 0))]
    (if (and (not (:edit-mode? props))
             removed-since-empty?)
      nil
      [card/expandable-card
       {:title                (if removed-since-empty?
                                (str (if (cu/blank-value? name)
                                       (->> figures
                                            :headers
                                            (first)
                                            :cols
                                            (first))
                                       name)
                                     "No data provided (table will be hidden)")
                                name)
        :removed-since-empty? removed-since-empty?}
       [:<>
        [dynamic-table
         {:parsed-data               (:figures data)
          :odd-row-background-color  (theme/color [:lp-report :table :odd-row :bg])
          :even-row-background-color (theme/color [:lp-report :table :even-row :bg])
          :sub-heading-color         (theme/color [:lp-report :table :subheading-color :bg])
          :sub-total-color           (theme/color [:lp-report :table :subtotal-color :bg])
          :total-color               (theme/color [:lp-report :table :total-color :bg])
          :empty-line-color          (theme/color [:lp-report :table :empty-line-color :bg])}]
        (when-not (or (:hide-footnote? props) removed-since-empty?) (text-content/optional-footnote data props))]])))
